import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { set as _set } from 'lodash'

Vue.use(VueI18n)

function loadLocaleMessages () {
    const locales = require.context('./locales', true, /\.json$/)
    const messages = {}
  
    locales.keys().forEach(key => {
      const keyPath = key.split('/').slice(1).join('.').replace(/\.json$/, '')
  
      _set(messages, keyPath, locales(key))
    })
  
    return messages
}
  
export default new VueI18n({
    locale: 'en', // 设置地区
    messages: loadLocaleMessages(), // 设置地区信息
})